/* ==========================================================================
   COLLECTION FILTERS

   Filters the cards already rendered on the page. Jewellery collections are
   in the hundreds, not the hundred-thousands, so a round trip per click would
   be slower and no more correct. The cards are real server-rendered links, so
   the page still works with JS off — filtering is the enhancement, not the
   content.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-collection]');
  if (!root) return;

  var PAGE = 24;
  var shown = PAGE;
  var state = { metals: [], styles: [], shapes: [], min: null, max: null, sort: 'featured' };

  function $(s) { return root.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  var grid = $('[data-grid]');
  var cards = $$('.pc');
  // Remember the server's order so "Featured" can always be restored.
  cards.forEach(function (c, i) { c.dataset.order = i; });

  function matches(c) {
    if (state.metals.length && state.metals.indexOf(c.dataset.metal) === -1) return false;
    if (state.styles.length && state.styles.indexOf(c.dataset.style) === -1) return false;
    if (state.shapes.length && state.shapes.indexOf(c.dataset.shape) === -1) return false;
    var p = parseFloat(c.dataset.price);
    if (state.min !== null && p < state.min) return false;
    if (state.max !== null && p > state.max) return false;
    return true;
  }

  function apply() {
    var list = cards.filter(matches);

    var dir = state.sort.indexOf('-desc') > -1 ? -1 : 1;
    if (state.sort.indexOf('price') === 0) {
      list.sort(function (a, b) {
        return (parseFloat(a.dataset.price) - parseFloat(b.dataset.price)) * dir;
      });
    } else if (state.sort === 'title-asc') {
      list.sort(function (a, b) {
        return a.querySelector('.pc__title').textContent
          .localeCompare(b.querySelector('.pc__title').textContent);
      });
    } else {
      list.sort(function (a, b) { return a.dataset.order - b.dataset.order; });
    }

    cards.forEach(function (c) { c.hidden = true; });
    list.slice(0, shown).forEach(function (c) { c.hidden = false; grid.appendChild(c); });

    var n = list.length;
    $('[data-count]').innerHTML = n
      ? '<b>' + n + '</b> ' + (n === 1 ? 'piece' : 'pieces')
      : 'Nothing matches';

    var empty = $('[data-empty]');
    empty.hidden = n > 0;

    var more = $('[data-more-wrap]');
    if (more) {
      more.hidden = shown >= n;
      var btn = more.querySelector('button');
      if (btn) btn.textContent = 'Load more — showing ' + Math.min(shown, n) + ' of ' + n;
    }

    writeUrl();
  }

  function writeUrl() {
    try {
      var p = new URLSearchParams();
      if (state.metals.length) p.set('metal', state.metals.join(','));
      if (state.styles.length) p.set('style', state.styles.join(','));
      if (state.shapes.length) p.set('shape', state.shapes.join(','));
      if (state.min !== null) p.set('min', state.min);
      if (state.max !== null) p.set('max', state.max);
      if (state.sort !== 'featured') p.set('sort', state.sort);
      var q = p.toString();
      history.replaceState(null, '', q ? '?' + q : location.pathname);
    } catch (e) { /* data: origins reject replaceState */ }
  }

  function readUrl() {
    var p = new URLSearchParams(location.search);
    if (p.get('metal')) state.metals = p.get('metal').split(',');
    if (p.get('style')) state.styles = p.get('style').split(',');
    if (p.get('shape')) state.shapes = p.get('shape').split(',');
    if (p.get('min')) state.min = +p.get('min');
    if (p.get('max')) state.max = +p.get('max');
    if (p.get('sort')) state.sort = p.get('sort');
  }

  function multi(attr, key) {
    $$('[data-f-' + attr + ']').forEach(function (b) {
      var v = b.getAttribute('data-f-' + attr);
      b.setAttribute('aria-pressed', String(state[key].indexOf(v) > -1));
      b.addEventListener('click', function () {
        var i = state[key].indexOf(v);
        if (i > -1) state[key].splice(i, 1); else state[key].push(v);
        b.setAttribute('aria-pressed', String(i === -1));
        shown = PAGE;
        apply();
      });
    });
  }

  function bind() {
    multi('metal', 'metals');
    multi('style', 'styles');
    multi('shape', 'shapes');

    ['min', 'max'].forEach(function (k) {
      var el = $('[data-price-' + k + ']');
      if (!el) return;
      if (state[k] !== null) el.value = state[k];
      el.addEventListener('change', function () {
        var v = parseFloat(el.value.replace(/[^0-9.]/g, ''));
        state[k] = isNaN(v) ? null : v;
        shown = PAGE;
        apply();
      });
    });

    var sort = $('[data-sort]');
    if (sort) {
      sort.value = state.sort;
      sort.addEventListener('change', function () { state.sort = sort.value; apply(); });
    }

    // There are two Clear controls — the toolbar and the empty state. Binding
    // only the first left the empty state's button dead, which is exactly when
    // a visitor most needs it.
    $$('[data-clear]').forEach(function (clear) {
      clear.addEventListener('click', function () {
      state.metals = []; state.styles = []; state.shapes = [];
      state.min = null; state.max = null;
      $$('[aria-pressed="true"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      ['min', 'max'].forEach(function (k) {
        var el = $('[data-price-' + k + ']'); if (el) el.value = '';
      });
      shown = PAGE;
      apply();
      });
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-more]')) { shown += PAGE; apply(); }
    });
  }

  readUrl();
  bind();
  apply();
})();
